import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChangeCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"change_circle"}/>
}
